// @flow
import React from "react";
import glamorous from "glamorous";
import Button from "../Button";

import type { propsType } from "../Button";

const GButton = glamorous(Button)({
	"&:hover": {
		textDecoration: "underline",
	},
	"&:active": {
		opacity: 0.8,
	},
	paddingTop: 0,
	paddingBottom: 0,
	paddingLeft: 0,
	paddingRight: 0,
});

export const LinkButton = (props: propsType) => {
	const btnProps = {
		...props,
		textColorName: "link",
		noPseudo: true,
	};

	return <GButton {...btnProps}/>;
};


export default LinkButton;
